import { Component, Input } from '@angular/core';
@Component({
  selector: 'sky-excess-form-section',
  templateUrl: './excess-form-section.component.html',
  styleUrls: ['./excess-form-section.component.scss'],
})
export class ExcessFormSectionComponent {
  @Input() fee: number | undefined;
  @Input() ltPrice = 0;
  @Input() monthlyFee = 0;
  @Input() hasLt = false;
}
